// extracted by mini-css-extract-plugin
export var button = "_ds-0";
export var icon = "_ds-1";